import { fmt } from "../../lib/utils/time";
import pumpkin from "../../assets/pumpkin.svg";

const ModeDisplay = ({
  step,
  stencilData,
  setSelectedMode,
  selectedMode,
  stencilWeek,
  time,
}) => {
  // 🔹 stencilWeek could be null
  // if user hasn't pick the week， we set [traced / carved] = 0（Not started）
  const tracedValue = stencilWeek ? stencilWeek.traced : 0;
  const carvedValue = stencilWeek ? stencilWeek.carved : 0;

  return (
    <>
      {/* Picking Tracing / Carving 's PAGE*/}
      {step === "mode" && stencilData && (
        <>
          <p className="vol-checktitle">
            <strong>Choose a step</strong>
          </p>

          <div className="vol-choice-grid">
            {/* Tracing Button */}
            <button
              type="button"
              className={`vol-choice ${
                selectedMode === "tracing" ? "selected" : ""
              }`}
              onClick={() => setSelectedMode("tracing")}
            >
              <span className="vol-choice-title">Tracing</span>
              <span className="vol-choice-sub">Outline the design</span>
            </button>

            {/* Carving Button */}
            <button
              type="button"
              className={`vol-choice ${
                selectedMode === "carving" ? "selected" : ""
              }`}
              onClick={() => setSelectedMode("carving")}
            >
              <span className="vol-choice-title">Carving</span>
              <span className="vol-choice-sub">Cut the pumpkin</span>
            </button>
          </div>

          <p className="vol-foot">
            You'll confirm your choice before starting the timer.
          </p>
        </>
      )}

      {/* Tracing Timing Page */}
      {step === "tracing" && stencilData && (
        <>
          <p className="vol-subtle">Tracing Stencil</p>
          <div className="vol-stencil-title">
            {stencilData.stencil.name}{" "}
            <span className="vol-stencil-id">· {stencilData.stencil.id}</span>
          </div>
          <div className="vol-timer">{fmt(time)}</div>
          <img src={pumpkin} alt="" aria-hidden="true" className="vol-illust" />
        </>
      )}

      {/* Carving Timing Page */}
      {step === "carving" && stencilData && (
        <>
          <p className="vol-subtle">Carving Stencil</p>
          <div className="vol-stencil-title">
            {stencilData.stencil.name}{" "}
            <span className="vol-stencil-id">· {stencilData.stencil.id}</span>
          </div>
          <div className="vol-timer">{fmt(time)}</div>
          <img src={pumpkin} alt="" aria-hidden="true" className="vol-illust" />
        </>
      )}
    </>
  );
};

export default ModeDisplay;

